<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="发布人" >
        <a-input disabled v-model="form.publisherName" placeholder="请输入发布人" />
      </a-form-model-item>-->
      <a-form-model-item label="发布人类型" prop="publisherType" >
        <a-select disabled v-model="form.publisherType" placeholder="请选择发布人类型">
          <a-select-option :value="1">医院</a-select-option>
          <a-select-option :value="2">科室</a-select-option>
          <a-select-option :value="3">医师</a-select-option>
          <a-select-option :value="4">平台</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type" >
        <a-select disabled v-model="form.type" placeholder="请选择类型">
          <a-select-option :value="1">文章</a-select-option>
          <a-select-option :value="2">视频</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title" >
        <a-input disabled v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="正文" prop="content" >
        <a-input disabled v-model="form.content" type="textarea" :rows="6" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="imageArr" v-if="form.imageArr">
        <img  v-for="(item, index) in form.imageArr.split(',')" :key="index" :src="processImageUrl(item)" style="width: 100px; height: 100px;">
      </a-form-model-item>
      <a-form-model-item label="视频" prop="videoUrl" v-if="form.videoUrl">
        <video :src="processImageUrl(form.videoUrl)" controls="controls" style="width: 100px; height: 100px;"></video>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select :disabled="isInfo != 1" v-model="form.status" placeholder="请选择状态">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">通过</a-select-option>
          <a-select-option :value="-1">驳回</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == -1">
        <a-input :disabled="isInfo != 1" v-model="form.rejectReason" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button v-if="isInfo == 1" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getArticle, addArticle, checkArticle } from '@/api/article/article'
import { processImageUrl } from '@/utils/util'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:1,
      // 表单参数
      form: {
        id: null,
        publisher: null,
        publisherName: null,
        publisherType: null,
        type: null,
        title: null,
        content: null,
        imageArr: null,
        videoUrl: null,
        status: 0,
        rejectReason: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // publisher: [
        //   { required: true, message: '发布人｛hospital.id;depart.id;doctor.id｝不能为空', trigger: 'blur' }
        // ],
        // publisherType: [
        //   { required: true, message: '发布人类型 1-医院 2-科室 3-医师不能为空', trigger: 'change' }
        // ],
        // type: [
        //   { required: true, message: '类型 1-文章 2-视频不能为空', trigger: 'change' }
        // ],
        // title: [
        //   { required: true, message: '标题不能为空', trigger: 'blur' }
        // ],
        // content: [
        //   { required: true, message: '正文不能为空', trigger: 'blur' }
        // ],
        // status: [
        //   { required: true, message: '状态 0-待审核 1-通过 -1-驳回不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    processImageUrl,
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        publisher: null,
        publisherName: null,
        publisherType: null,
        type: null,
        title: null,
        content: null,
        imageArr: null,
        videoUrl: null,
        status: 0,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    handleInfo(record){
      this.open = true
      this.reset()
      this.formType = 2
      this.isInfo = 2
      getArticle({"id":record.id}).then(response => {
        this.form = response.data
        console.log('status',this.form.status)
        this.formTitle = '详情'
      })

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.isInfo = 1
      const id = row ? row.id : ids
      getArticle({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            checkArticle(this.form).then(response => {
              this.$message.success(
                '成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addArticle(this.form).then(response => {
              this.$message.success(
                '成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
